module.exports = __webpack_public_path__ + "imgs/study-owl.ed8c18fcae1f7f5d6b492a9f4223d6cd.svg";